import React from "react";

export default function QuestionModeToggle({ mode, onChange, isDarkMode }) {
  return (
    <div
      className={`inline-flex shrink-0 rounded-xl border ${isDarkMode ? 'border-slate-600 bg-slate-700' : 'border-slate-200 bg-white'} p-0.5 sm:p-1`}
      data-tour="question-mode-toggle"
    >
      <button
        type="button"
        onClick={() => onChange("practice")}
        className={`px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm font-semibold rounded-lg transition ${
          mode === "practice"
            ? "bg-indigo-600 text-white"
            : isDarkMode
            ? "text-slate-300 hover:bg-slate-600"
            : "text-slate-600 hover:bg-slate-50"
        }`}
      >
        Practice
      </button>
      <button
        type="button"
        onClick={() => onChange("exam")}
        className={`px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm font-semibold rounded-lg transition ${
          mode === "exam"
            ? "bg-indigo-600 text-white"
            : isDarkMode
            ? "text-slate-300 hover:bg-slate-600"
            : "text-slate-600 hover:bg-slate-50"
        }`}
      >
        Exam Mode
      </button>
    </div>
  );
}
